export const ENV = {
  mapStyleUrl: import.meta.env.VITE_MAP_STYLE_URL || "https://tiles.openfreemap.org/styles/liberty"
};
